/**
 * Returns a capitalized version of a string
 * @param inputString
 * @returns {string}
 */
function capitalize(inputString = '') {

  if (inputString.length === 1) return inputString.toUpperCase();

  const firstChar = inputString[0] || '';
  const remainingChars = inputString.slice(-(inputString.length - 1));

  return firstChar.toUpperCase() + remainingChars.toLowerCase();
}

export default capitalize;
